// @flow
import React from 'react';
import classNames from 'classnames';

import './Label.css';

type Props = {
  children: any,
  style?: Object,
  querySelector?: string,
  inline?: boolean
};

class Label extends React.Component<Props, {}> {
  static defaultProps = {
    style: {}
  };

  onClick = () => {
    const target = this._node.querySelector(this.props.querySelector);
    if (target && target.click) {
      target.click();
    }
  };

  render() {
    const { style, children, querySelector, inline } = this.props;

    const props = {
      name: 'Label',
      className: classNames({ inline }),
      style
    };

    if (querySelector) {
      props.ref = (node) => (this._node = node);
      props.onClick = this.onClick;
    }

    return <label {...props}>{children}</label>;
  }
}

export default Label;
